<!-- HEADER START -->
<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md">
      <ion-title color="secondary" class="ion-text-center header-title">Obveščanje</ion-title>
      <ion-buttons slot="start" class="header-buttons">
        <ion-back-button color="secondary" defaultHref="/"></ion-back-button>
      </ion-buttons>
      <!--<ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
        <ion-button [routerLink]="['/']" class="header-buttons__btn">
          <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
        </ion-button>
      </ion-buttons>-->

      <app-top-right slot="end"></app-top-right>

    </ion-toolbar>
  </ion-grid>
</ion-header>
<!-- HEADER END -->
<ion-content class="ion-padding" *ngIf="me$ | async as me">
  <ion-grid fixed class="ion-no-padding">

  <h3>Ugodnosti in novice</h3>
  <small>Zvestim strankam pošiljamo akcijsko ponudbo, ugodnosti in novice, npr. posebej ugodne ponudbe v zadnjem hipu.</small>

  <ion-list>

    <ion-item class="ion-no-padding">
      <ion-label>Ugodnosti in novice Table42 po e-pošti</ion-label>
      <ion-toggle color="tertiary" [checked]="me.promotionsViaEmail" (ionChange)="marketplaceToggle$.next( {'promotionsViaEmail': $event.target.checked } )"  disabled="false"></ion-toggle>
    </ion-item>

    <ion-item class="ion-no-padding">
      <ion-label>Ugodnosti in novice Table42 po SMS-ih</ion-label>
      <ion-toggle color="tertiary" [checked]="me.promotionsViaSms" (ionChange)="marketplaceToggle$.next( {'promotionsViaSms': $event.target.checked } )" disabled="false"></ion-toggle>
    </ion-item>

    <ng-container *ngFor="let pu of me.providerUsers; let  i = $index">

    <ion-item class="ion-no-padding" >
      <ion-label>Ugodnosti in novice {{ pu.provider.brandName }} po e-pošti</ion-label>
      <ion-toggle color="tertiary" [checked]="pu.promotionsViaEmail" (ionChange)="providerToggle$.next([ pu.provider.id, {'promotionsViaEmail': $event.target.checked, 'newsletter': $event.target.checked}])" disabled="false"></ion-toggle>
    </ion-item>

    <ion-item class="ion-no-padding" >
      <ion-label>Ugodnosti in novice {{ pu.provider.brandName }} po SMS-ih</ion-label>
      <ion-toggle color="tertiary" [checked]="pu.promotionsViaSms" (ionChange)="providerToggle$.next([ pu.provider.id, {'promotionsViaSms': $event.target.checked}])" disabled="false"></ion-toggle>
    </ion-item>

    </ng-container>

  </ion-list>

  <h3>Opomnik in obvestila</h3> 
  <small>Ob vsakem naročilu pošljemo potrditev. Pred vašim terminom vam pošljemo tudi opomnik. Obvestimo vas tudi o morebitni spremembi termina ali odpovedi.</small>

  <ion-list>

    <ion-item class="ion-no-padding">
      <ion-label>*Opomnik in obvestila po e-pošti</ion-label>
      <ion-toggle color="tertiary" [checked]="true" disabled="true"></ion-toggle>
    </ion-item>

    <ion-item class="ion-no-padding">
      <ion-label>*Opomnik in obvestila po SMS-ih</ion-label>
      <ion-toggle color="tertiary" [checked]="true"  disabled="true"></ion-toggle>
    </ion-item>

    <ion-item class="ion-no-padding">
      <ion-label>*Anketa o zadovoljstvu</ion-label>
      <ion-toggle color="tertiary" [checked]="true"  disabled="true"></ion-toggle>
    </ion-item>

  </ion-list>

  <small>* Z željo, da gostom zagotovimo čim boljšo izkušnjo, v skladu z uredbo GDPR (legitimni interes), pošiljamo opomnike in obvestila glede rezervacij, s čimer želimo zmanjšati verjetnost neprihodov ali preprečiti zamudo. Več si preberite v <u>politiki varovanja osebnih podatkov</u>.</small>

  </ion-grid>
</ion-content>
